import events from './lib/events';

export { default } from './insights';
export { CLIENT_ID_COOKIE_NAME } from './insights';
export { ANALYTICS_ID_COOKIE_NAME } from './insights';
export const PageProperties = events.PageProperties;
export const EventProperties = events.EventProperties;
export const ObjectProperties = events.ObjectProperties;
